module.exports = __webpack_public_path__ + "static/media/img_0.b430ae20.png";